import React from 'react';
import Section from '../components/Section';

export default function About() {
  return (
    <Section id="about" title="About">
      <p className="section-text">
        Hi, I'm <strong>Sreedeep</strong>. I focus on securing web and mobile applications,
        with hands-on experience in Burp Suite, Wireshark, and vulnerability assessment.
        I write regularly for <em>Hacking Simplified</em> and compete in CTFs.
      </p>
      <ul className="section-list">
        <li>3rd Place — Cybe Sans CTF (CSA Bangalore, Aug 2025)</li>
        <li>7th — DEF CON Bug Bounty Village CTF (Aug 2025)</li>
        <li>1st — Paradox CTF 2022 (CEK)</li>
      </ul>
    </Section>
  );
}
